import React from "react";
import type { ComponentProps, PartData } from "@enonic/react-components";

import type { QuoteProps } from "./Quote.d";

export const QuotePart = (props: ComponentProps<PartData>) => {
  const { background, container, title, content } =
    (props.data as QuoteProps) ?? {};

  return (
    <section className={background}>
      <div className={`${container}`}>
        <h2 className="text-smallcaps">{title}:</h2>
        <p className="text-quote">“{content}”</p>
      </div>
    </section>
  );
};

export default QuotePart;
